module.exports = __webpack_public_path__ + "static/media/NoImg.7f7af9bb.svg";